import {Button as MUIButton} from '@mui/material';
import {styled} from '@mui/material/styles';

export const Button = styled(MUIButton)({
    boxShadow: 'none',
    borderRadius: '100px',
    textTransform: 'unset'
});
